export default {
  packinstalled: [],
  servicemonitoring: [],
  callingAPI: false,
  serverURI: 'http://intelisoftinformatique:9001', // Serveur d'authentification (voir src/api/index.js) - peut-être notre service FeathersJS
  user: null,
  token: null,
  userInfo: {
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js